import React from 'react';

import { Container } from '../Layout/Container';
import { Wrapper } from '../Layout';
import { AlternativeCertificates } from '../AlternativeCertificates/AlternativeCertificates';

import classes from './Footer.scss';
import { FooterMenu, FooterMenus } from './FooterMenus';
import { FooterContact } from './FooterContact';
import { FooterLogo } from './FooterLogo';

type Props = {
    jhMenu: FooterMenu[];
};

export const FooterBlack: React.FC<Props> = ({ jhMenu }) => {
    const computedjhMenu = jhMenu.filter((item) => item.title !== 'Services');
    return (
        <Wrapper className={classes.footer} element="footer" bg="black-1000">
            <Container variant="mobile-no-padding">
                <div className={classes.footerCtaBlack}>
                    <FooterLogo theme="black" />
                    <FooterMenus menus={computedjhMenu} theme="black" />
                </div>
                <AlternativeCertificates />
                <FooterContact theme="black" />
            </Container>
        </Wrapper>
    );
};
